/**
 * Builds a URL path from an array of string segments.
 * @param segments - Array of path segments to join
 * @returns The constructed URL path with leading slash
 * @example
 * buildUrlPath(['errors', 'forbidden']) // Returns: '/errors/forbidden'
 * buildUrlPath(['api', 'users', '123']) // Returns: '/api/users/123'
 */
export function buildUrlPath(segments: string[]): string {
  return `/${segments.join('/')}`;
}

/**
 * Builds a URL path from an array of string segments with optional query parameters.
 * @param segments - Array of path segments to join
 * @param queryParams - Optional object containing query parameters
 * @returns The constructed URL path with leading slash and optional query string
 * @example
 * buildUrlPathWithQuery(['api', 'users'], { page: 1, limit: 10 })
 * // Returns: '/api/users?page=1&limit=10'
 */
export function buildUrlPathWithQuery(
  segments: string[],
  queryParams?: Record<string, string | number | boolean>
): string {
  const path = buildUrlPath(segments);

  if (!queryParams || Object.keys(queryParams).length === 0) {
    return path;
  }

  const queryString = Object.entries(queryParams)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join('&');

  return `${path}?${queryString}`;
}
